import useGetZoneMarkupFile from '../hooks/useGetZoneMarkupFile';
import {  Loading } from '@sede-enterprise/shell-ds-react-framework'
import './ZoneMarkupContent.css';
const ZoneMarkupContent = ({ id }) => {
    const { data, isLoading, isError } = useGetZoneMarkupFile(id); // Custom hook to fetch zone markup data
    return (
        <div>
            {isLoading && <Loading />}
            {!isLoading && data && <iframe src={data} width="100%" height="600px" title="Zone Markup PDF" />}
        </div>
    );
};

export default ZoneMarkupContent;
